module.exports = __webpack_public_path__ + "img/icon_j.156361f8.png";